import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Users, Vote, AlertTriangle, Upload, UserCheck,
  MapPin, LogOut, BarChart3, Shield
} from 'lucide-react';

const adminLinks = [
  { path: '/admin', icon: LayoutDashboard, label: 'Command Center' },
  { path: '/admin/manage', icon: Users, label: 'Manage Users' },
  { path: '/admin/assign', icon: MapPin, label: 'Assign Precincts' },
  { path: '/admin/candidates', icon: Vote, label: 'Candidates' },
  { path: '/admin/import', icon: Upload, label: 'Import Voters' },
  { path: '/admin/anomalies', icon: AlertTriangle, label: 'Anomalies' },
];

const tlLinks = [
  { path: '/team-leader', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/team-leader/assign', icon: MapPin, label: 'Assign Precincts' },
];

const surveyorLinks = [
  { path: '/surveyor', icon: MapPin, label: 'Survey' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const links = user?.role === 'admin' ? adminLinks
    : user?.role === 'team_leader' ? tlLinks
    : surveyorLinks;

  const roleLabel = user?.role === 'admin' ? 'Admin'
    : user?.role === 'team_leader' ? 'Team Leader'
    : 'Surveyor';

  const roleIcon = user?.role === 'admin' ? Shield
    : user?.role === 'team_leader' ? BarChart3
    : UserCheck;

  const RoleIcon = roleIcon;

  return (
    <aside
      data-testid="sidebar"
      className="fixed left-0 top-0 h-screen w-64 bg-slate-950 flex flex-col z-50"
    >
      <div className="p-5 border-b border-slate-800">
        <h1 className="text-white font-heading text-lg font-bold tracking-tight">
          Survey Command
        </h1>
        <p className="text-slate-500 text-xs mt-1 uppercase tracking-widest">Center</p>
      </div>

      <div className="px-4 py-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <RoleIcon className="w-4 h-4 text-blue-400" />
          <span className="text-slate-300 text-sm font-medium">{roleLabel}</span>
        </div>
        <p className="text-slate-500 text-xs mt-1 truncate">{user?.name}</p>
      </div>

      <nav className="flex-1 py-4 overflow-y-auto">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          return (
            <button
              key={link.path}
              data-testid={`sidebar-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              onClick={() => navigate(link.path)}
              className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-colors ${
                isActive
                  ? 'bg-slate-800 text-white border-l-4 border-blue-500 pl-4'
                  : 'text-slate-400 hover:text-white hover:bg-slate-900 border-l-4 border-transparent pl-4'
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
              {link.label}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-800">
        <button
          data-testid="sidebar-logout"
          onClick={() => { logout(); navigate('/login'); }}
          className="flex items-center gap-3 text-slate-400 hover:text-white text-sm w-full transition-colors"
        >
          <LogOut className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
